import { render, staticRenderFns } from "./ParentAccount.vue?vue&type=template&id=99760c9c&scoped=true"
import script from "./ParentAccount.vue?vue&type=script&lang=js"
export * from "./ParentAccount.vue?vue&type=script&lang=js"
import style0 from "./ParentAccount.vue?vue&type=style&index=0&id=99760c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99760c9c",
  null
  
)

export default component.exports